import React, { useContext } from 'react';
import {
  DetailContext,
  DetailMode,
  EvidenceContext,
  UserContext,
} from '@eas/common-web';
import {
  LOAN_SOURCE,
  VIEWING_REQUEST_SOURCE,
} from '@modules/es-file/es-file-hooked-sources';
import { LoanField } from '@composite/loans/loan-field';
import { ViewingRequestField } from '@composite/viewing-requests/viewing-request-field';
import { Role } from '@enums';

export function ViewingsAndLoansFields() {
  const { hookedSources } = useContext(EvidenceContext);
  const { mode } = useContext(DetailContext);
  const { hasPermission } = useContext(UserContext);

  const disabledViewingRequests =
    mode !== DetailMode.VIEW || !hasPermission(Role.VIEWING_REQUEST_MANAGER);

  const viewingRequestsSource = hookedSources[VIEWING_REQUEST_SOURCE]?.source;
  const loansSource = hookedSources[LOAN_SOURCE]?.source;

  return (
    <>
      <ViewingRequestField
        disabled={disabledViewingRequests}
        source={viewingRequestsSource}
      />
      <LoanField source={loansSource} />
    </>
  );
}
